import {NgModule} from '@angular/core';
import {TableColumnMovingGhostComponent} from './table-column-moving-ghost.component';

@NgModule({
    declarations: [
        TableColumnMovingGhostComponent
    ]
})
export class TableColumnReorderModule {}
